import { ReactElement, useContext } from 'react'

import {
  FieldValues,
  useFormContext,
  UseFormSetValue,
  useWatch
} from 'react-hook-form'

import { CustomContext } from './CustomProvider'

export function Data<T extends FieldValues>({
  children
}: {
  children: (
    values: T,
    props: { setValue: UseFormSetValue<T>; readOnly: boolean }
  ) => ReactElement | null
}) {
  const { setValue } = useFormContext<T>()
  const { readOnly } = useContext(CustomContext)
  const values = useWatch<T>()

  return children(values as T, { setValue, readOnly })
}

export function SpecificData<T>({
  name,
  children
}: {
  name: string
  children: (values: T, props: { readOnly: boolean }) => ReactElement | null
}) {
  const { readOnly } = useContext(CustomContext)
  const value = useWatch({ name })

  return children(value as T, { readOnly })
}
